module.exports = __webpack_public_path__ + "img/tarj1-2.c9d73b05.svg";